import { appKillSelf } from "@droid/android";
import { useTranslation } from "@fanfanlo";
import { Button } from "@mui/material";
import toast from "react-hot-toast";

export function KillSelf(){
    const {t} = useTranslation("homepage/components/app/kill-self/content")
    async function onClick(){
        toast.success(t("KillSelf.toast"))
        await new Promise(r=>setTimeout(r, 1000 * 1))
        appKillSelf()
    }
    return(
        <>
            <Button onClick={onClick} data-testid="KillSelf__killButton__01JG2B0083" data-test-comment="应用退出按钮，点击后显示提示信息，1秒后关闭应用">
                {t("KillSelf.name")}
            </Button>
        </>
    )
}